/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import React, { useState, useEffect, useRef } from 'react'
import StatsOverview from './StatsOverview';
import FiltersPanel from './FiltersPanel';
import CategoryTabs from './CategoryTabs';
import PatientTable from './PatientTable';
import AnalyticsSection from './AnalyticsSection';
import * as API from "Front/api/emr";
import { labTestList } from '../../../api/home';
import { treatmentWithType } from '../../../api/master';
import { starStatusList } from '../../../api/home';


const AnalyticsDashboard = () => {
    const [selectedFilters, setSelectedFilters] = useState({})
    const [symptomsCategoryList, setSymptomsCategoryList] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(localStorage.getItem("clinicId"))
    const [selectedCategoryType, setSelectedCategoryType] = useState("clinic")
    const [diagnosisEnlarge, setDiagnosisEnlarge] = useState({
        type: "longTerm",
        diagnosisCategoryId: localStorage.getItem("clinicId"),
        longTermArr: [],
        interCurrentArr: [],
    });
    const [diagnosisCategoryList, setDiagnosisCategoryList] = useState([])
    const [labTests, setLabTests] = useState([])
    const [treatments, setTreatments] = useState([])
    const [startStatusList, setStarStatusList] = useState([])
    const [isStatsOverviewOpen, setIsStatsOverviewOpen] = useState(false);
    const [isCategoryTabsOpen, setIsCategoryTabsOpen] = useState(true);
    const [isPatientTableOpen, setIsPatientTableOpen] = useState(true);
    const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
    const [stats, setStats] = useState({})
    const containerRef = useRef(null);
    const [patientList, setPatientList] = useState([]);
    const [formData, setFormData] = useState({ limit: 10, page: 0, direction: "" });
    const [totalCount, setTotalCount] = useState(0);


    const labTestRanges = {
        "GLUCOSE (FASTING)": [
            { label: "70-100", value: "70-100", startRange: 70, endRange: 100 },
            { label: "100-125", value: "100-125", startRange: 100, endRange: 125 },
            { label: "Above 125", value: "Above 125", startRange: 125, endRange: 1000000 }
        ],
        "GLUCOSE (POSTPRANDIAL)": [
            { label: "70-140", value: "70-140", startRange: 70, endRange: 140 },
            { label: "140-200", value: "140-200", startRange: 140, endRange: 200 },
            { label: "Above 200", value: "Above 200", startRange: 200, endRange: 1000000 }
        ],
        "GLUCOSE (RANDOM)": [
            { label: "70-140", value: "70-140", startRange: 70, endRange: 140 },
            { label: "140-200", value: "140-200", startRange: 140, endRange: 200 },
            { label: "Above 200", value: "Above 200", startRange: 200, endRange: 1000000 }
        ],
        "HBA1c": [
            { label: "Below 5.7", value: "Below 5.7", startRange: 0, endRange: 5.7 },
            { label: "5.7-6.4", value: "5.7-6.4", startRange: 5.7, endRange: 6.4 },
            { label: "Above 6.4", value: "Above 6.4", startRange: 6.4, endRange: 1000000 }
        ],
        "Total Cholesterol": [
            { label: "Less than 200", value: "Less than 200", startRange: 0, endRange: 200 },
            { label: "200-239", value: "200-239", startRange: 200, endRange: 239 },
            { label: "240 and above", value: "240 and above", startRange: 240, endRange: 1000000 }
        ],
        "Triglyceride": [
            { label: "Less than 150", value: "Less than 150", startRange: 0, endRange: 150 },
            { label: "150-199", value: "150-199", startRange: 150, endRange: 199 },
            { label: "200-499", value: "200-499", startRange: 200, endRange: 499 },
            { label: "Above 500", value: "Above 500", startRange: 500, endRange: 1000000 }
        ],
        "HDL Cholesterol": [
            { label: "Less than 40", value: "Less than 40", startRange: 0, endRange: 40 },
            { label: "40-59", value: "40-59", startRange: 40, endRange: 59 },
            { label: "Above 60", value: "Above 60", startRange: 60, endRange: 1000000 }
        ],
        "LDL Cholesterol": [
            { label: "Less than 100", value: "Less than 100", startRange: 0, endRange: 100 },
            { label: "100-129", value: "100-129", startRange: 100, endRange: 129 },
            { label: "130-159", value: "130-159", startRange: 130, endRange: 159 },
            { label: "160 and above", value: "160 and above", startRange: 160, endRange: 1000000 }
        ],
        "Serum Creatinine": [
            { label: "0.6-1.2", value: "0.6-1.2", startRange: 0.6, endRange: 1.2 },
            { label: "Above 1.2", value: "Above 1.2", startRange: 1.2, endRange: 1000000 }
        ],
        "BUN": [
            { label: "7-20", value: "7-20", startRange: 7, endRange: 20 },
            { label: "Above 20", value: "Above 20", startRange: 20, endRange: 1000000 }
        ],
        "ALBUMIN CREATININE RATIO": [
            { label: "Below 30", value: "Below 30", startRange: 0, endRange: 30 },
            { label: "30-300", value: "30-300", startRange: 30, endRange: 300 },
            { label: "Above 300", value: "Above 300", startRange: 300, endRange: 1000000 }
        ],
        "HB": [
            { label: "13-17", value: "13-17", startRange: 13, endRange: 17 },
            { label: "Below 13", value: "Below 13", startRange: 0, endRange: 13 }
        ],
        "TOTAL LEUCOCYTE COUNT": [
            { label: "4000-11000", value: "4000-11000", startRange: 4000, endRange: 11000 }
        ],
        "Platelets": [
            { label: "150-450", value: "150-450", startRange: 150, endRange: 450 }
        ],
        "SGOT (IU/l)": [
            { label: "10-40", value: "10-40", startRange: 10, endRange: 40 }
        ],
        "SGPT": [
            { label: "10-40", value: "10-40", startRange: 10, endRange: 40 }
        ],
        "Uric Acid": [
            { label: "3.5-7.2", value: "3.5-7.2", startRange: 3.5, endRange: 7.2 }
        ],
        "Free T4": [
            { label: "0.7-1.8", value: "0.7-1.8", startRange: 0.7, endRange: 1.8 }
        ],
        "THYROXINE (TOTAL T4)": [
            { label: "4.5-11.2", value: "4.5-11.2", startRange: 4.5, endRange: 11.2 }
        ],
        "THYRONINE (T3)": [
            { label: "0.8-2.0", value: "0.8-2.0", startRange: 0.8, endRange: 2.0 }
        ],
        "THYROID STIMULATING HORMONE": [
            { label: "0.4-4.0", value: "0.4-4.0", startRange: 0.4, endRange: 4.0 }
        ],
        "C Peptide Stimulated": [
            { label: "0.5-2.0", value: "0.5-2.0", startRange: 0.5, endRange: 2.0 }
        ],
        "Fasting Insulin": [
            { label: "2-25", value: "2-25", startRange: 2, endRange: 25 }
        ]
    };





    const handleFilters = (category, filters) => {
        if (!isFilterPanelOpen) setIsFilterPanelOpen(true)
        const cloneSelectedFilters = selectedFilters
        cloneSelectedFilters[category] = filters
        setSelectedFilters({ ...cloneSelectedFilters })
    }

    const removeFilter = (filter) => {
        const selectedValues = selectedFilters[filter.category];
        const updatedValues = selectedValues?.filter((ele) => ele?.id !== filter?.id);
        const updatedFilters = { ...selectedFilters };
        if (updatedValues?.length === 0) {
            delete updatedFilters[filter.category];
        } else {
            updatedFilters[filter.category] = updatedValues;
        }
        if (Object.keys(updatedFilters).length === 0) {
            setIsFilterPanelOpen(false)
            setIsStatsOverviewOpen(false)
            const scrollElement = document.querySelector(".ps");
            if (scrollElement) scrollElement.scrollTop = 0;
        }
        setSelectedFilters(updatedFilters);
    };


    const getSymptomsCategory = async () => {
        let resp = await API.symptomsCategory();
        if (
            resp.data &&
            resp.data.status === "Success" &&
            resp.data.masterSymptomsCategoryList.data.length > 0
        ) {
            setSymptomsCategoryList(resp.data.masterSymptomsCategoryList.data);
        }
    };

    const getDiagnosisCategory = async () => {

        let req = { "type": diagnosisEnlarge?.type }
        let catType = ""
        let resp = await API.diagonsisCategory(req);
        if (resp.data && resp.data.status === "Success") {

            //   let radioCategory = document.getElementById(type + "Enlarge");
            //   if (radioCategory !== null)
            //     radioCategory.checked = true

            setDiagnosisCategoryList(resp.data.diagonsisCategoryList.data)
            //   if (onPageLoad) {
            //     activateTab(DiagnosisEnlarge.diagonsisCategoryId)
            //     diagonsisCategoryId = DiagnosisEnlarge.diagonsisCategoryId
            //     catType = "master"
            //   } else {
            //     let ele = document.getElementById("cat" + selectedCategoryIdEnlarge);
            //     if (ele !== null) {
            //       activateTab(selectedCategoryIdEnlarge)
            //       diagonsisCategoryId = selectedCategoryIdEnlarge
            //     } else {
            //       activateTab(resp.data.diagonsisCategoryList.data[0]._id)
            //       diagonsisCategoryId = resp.data.diagonsisCategoryList.data[0]._id
            //     }

            //   }

            //   catType = diagonsisCategoryId === patientId ? "patient" : diagonsisCategoryId === clinicId ? "clinic" : "category"
            //   getDiagnosisSubCategory("", catType)
        }
    }

    const handleDiagnosisType = (type) => {
        setDiagnosisEnlarge({ ...diagnosisEnlarge, type: type })
    }

    const getLabTestList = async () => {
        let res = await labTestList()
        if (res?.data?.status === "Success" && res?.data?.statusCode === 200) {
            if (res?.data?.testReportList && res?.data?.testReportList?.data?.length > 0) {
                let tempList = res?.data?.testReportList?.data
                for (let i in tempList) {
                    let obj = tempList[i]
                    let tempOptions = getLabTestRange(obj.name)
                    if (Array.isArray(tempOptions)) {
                        tempOptions = tempOptions.map((opt) => ({ ...opt, testId: obj._id }))
                        obj["options"] = tempOptions
                        tempList[i] = obj
                    }
                }
                setLabTests([...tempList])
            }
        }
    }

    const getLabTestRange = (testName) => {
        if (labTestRanges[testName]) {
            return labTestRanges[testName];
        } else {
            return `Range options for ${testName} not found.`;
        }
    }

    const getTreatmentWithTypeList = async () => {
        let res = await treatmentWithType()
        let tempTreatments = []
        if (res?.data?.status === "Success" && res?.data?.statusCode === 200) {
            if (res?.data?.data && res?.data?.data?.length > 0) {
                res.data.data.map((treatmentType) => {
                    if (treatmentType?.treatments && treatmentType?.treatments?.length > 0) {
                        const filteredTreatments = treatmentType.treatments.filter((t) => t.status === "active")
                        tempTreatments = [...tempTreatments, ...filteredTreatments]
                    }
                })
            }
        }
        tempTreatments = tempTreatments.map((treatment) => ({ ...treatment, label: treatment.name, value: treatment.name }))
        setTreatments(tempTreatments)
    }

    const handleClearAllFilters = () => {
        setSelectedFilters({})
    }

    const getStarStatusList = async () => {
        let res = await starStatusList()
        if (res?.data?.status === "Success" && res?.data?.statusCode === 200) {
            if (res?.data?.starStatusList && res?.data?.starStatusList?.data?.length > 0) {
                let tempList = res?.data?.starStatusList?.data
                tempList = tempList.map((ele) => ({ ...ele, label: ele.title, value: ele.title }))
                setStarStatusList([...tempList])
            }
        }
    }

    const toggleStatsOverview = () => setIsStatsOverviewOpen(!isStatsOverviewOpen);
    const toggleCategoryTabs = () => setIsCategoryTabsOpen(!isCategoryTabsOpen);
    const togglePatientTable = () => setIsPatientTableOpen(!isPatientTableOpen);
    const toggleFilterPanel = () => setIsFilterPanelOpen(!isFilterPanelOpen);

    useEffect(() => {
        if (symptomsCategoryList?.length === 0)
            getSymptomsCategory()
        if (diagnosisCategoryList?.length === 0)
            getDiagnosisCategory()
        if (labTests.length === 0)
            getLabTestList()
        if (treatments.length === 0)
            getTreatmentWithTypeList()
        if (startStatusList.length === 0) {
            getStarStatusList()
        }

    }, [])


    useEffect(() => {
        getDiagnosisCategory()
    }, [diagnosisEnlarge.type])

    const handleScrollToTop = () => {
        eval('$(".ps").scrollTop(0)');
    };

    return (
        <div className="container-fluid">
            <AnalyticsSection />
            <div className="accordion-container">
                <button className="accordion-button" onClick={toggleCategoryTabs}>
                    <span className="accordion-title">Category Tabs</span>
                    {isCategoryTabsOpen ? '-' : '+'}
                </button>
                <div className={`accordion-content ${isCategoryTabsOpen ? 'open' : 'closed'}`}>
                    {isCategoryTabsOpen && (
                        <CategoryTabs
                            handleFilters={(category, data) => handleFilters(category, data)}
                            selectedFilters={selectedFilters}
                            symptomsCategoryList={symptomsCategoryList}
                            selectedCategoryId={selectedCategoryId}
                            setSelectedCategoryId={setSelectedCategoryId}
                            selectedCategoryType={selectedCategoryType}
                            setSelectedCategoryType={setSelectedCategoryType}
                            diagnosisEnlarge={diagnosisEnlarge}
                            setDiagnosisEnlarge={setDiagnosisEnlarge}
                            diagnosisCategoryList={diagnosisCategoryList}
                            handleDiagnosisType={handleDiagnosisType}
                            labTestList={labTests}
                            treatments={treatments}
                            starStatusList={startStatusList}
                        />
                    )}
                </div>
            </div>
            {Object.keys(selectedFilters).length > 0 &&
                <div className="accordion-container">
                    <button className="accordion-button" onClick={toggleStatsOverview}>
                        <span className="accordion-title">Stats Overview</span>
                        {isStatsOverviewOpen ? '-' : '+'}
                    </button>
                    <div className={`accordion-content ${isStatsOverviewOpen ? 'open' : 'closed'}`}>
                        {isStatsOverviewOpen &&
                            <StatsOverview stats={stats} />
                        }
                    </div>
                </div>
            }
            <div className="accordion-container">
                <button className="accordion-button" onClick={toggleFilterPanel}>
                    {/* <span className="accordion-title">Filters</span> */}
                    <span className="accordion-title">Active Filters</span>

                    {isFilterPanelOpen ? '-' : '+'}
                </button>
                <div className={`max-h-fit accordion-content ${isFilterPanelOpen ? 'open' : 'closed'}`}>
                    {Object.keys(selectedFilters).length > 0 && isFilterPanelOpen &&
                        <FiltersPanel selectedFilters={selectedFilters} removeFilter={(filter) => removeFilter(filter)} />
                    }
                </div>
            </div>
            {Object.keys(selectedFilters).length > 0 &&
                <div className="accordion-container">
                    <button className="accordion-button" onClick={togglePatientTable}>
                        <span className="accordion-title">Patient Table</span>
                        {isPatientTableOpen ? '-' : '+'}
                    </button>
                    <div className={`accordion-content ${isPatientTableOpen ? 'open' : 'closed'}`}>
                        {isPatientTableOpen &&
                            <PatientTable
                                setSelectedFilters={setSelectedFilters}
                                selectedFilters={selectedFilters}
                                setStats={setStats}
                                scrollToTop={handleScrollToTop}
                                setIsFilterPanelOpen={setIsFilterPanelOpen}
                                patientList={patientList}
                                setPatientList={setPatientList}
                                formData={formData}
                                setFormData={setFormData}
                                totalCount={totalCount}
                                setTotalCount={setTotalCount}

                            />
                        }
                    </div>
                </div>
            }
        </div>
    );
};

export default AnalyticsDashboard;
